/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Individu, Parametre } from '@/types';

type ParametresStoreType = {
  parametresUser: Parametre;
  setParametresUser: (parametresUser: Parametre) => void;
  signataires: Partial<Individu>[];
  setSignataires: (signataires: Partial<Individu>[]) => void;
  defaultSignataire: Partial<Individu>;
  setDefaultSignataire: (defaultSignataire: Partial<Individu>) => void;
};

const useParametresStore = create<ParametresStoreType>()(
  devtools((set) => ({
    parametresUser: null,
    setParametresUser: (parametresUser) => set({ parametresUser }),
    signataires: [],
    setSignataires: (signataires) => set({ signataires }),
    defaultSignataire: null,
    setDefaultSignataire: (defaultSignataire) => set({ defaultSignataire }),
  })),
);

export default useParametresStore;
